import * as t from './types';
import { addNewsLetterAPI, addRecruitAPI, addProjectAPI, addPdsAPI } from './api';

export default {
  addNewsLetter({ commit }, payload) {
    commit(t.ADD_NEWSLETTER_PENDING);
    return Promise.resolve()
      .then(() => {
        return addNewsLetterAPI(payload);
      })
      .then(response => {
        const result = response.data || {};
        // const { info } = result.info || {}
        // const status = response.status || []
        commit(t.ADD_NEWSLETTER_SUCCESS, { result });
        return response;
      })
      .catch(err => {
        commit(t.ADD_NEWSLETTER_FAIL);
        throw err;
      });
  },
  addRecruit({ commit }, payload) {
    commit(t.ADD_RECRUIT_PENDING);
    return Promise.resolve()
      .then(() => {
        return addRecruitAPI(payload);
      })
      .then(response => {
        const result = response.data || {};
        console.log(result);
        // const { info } = result.info || {}
        // const status = response.status || []
        commit(t.ADD_RECRUIT_SUCCESS, { result });
        return response;
      })
      .catch(err => {
        commit(t.ADD_RECRUIT_FAIL);
        throw err;
      });
  },

  async addProject({ commit }, payload) {
    try {
      commit(t.ADD_PROJECT_PENDING);
      const response = await addProjectAPI(payload);
      if (response.data === undefined) throw Error;
      const { data: result = {} } = response;
      commit(t.ADD_PROJECT_SUCCESS, { result });
      return response;
    } catch (err) {
      commit(t.ADD_PROJECT_FAIL);
      throw err;
    }
  },
  addPds({ commit }, payload) {
    commit(t.ADD_PDS_PENDING);
    return Promise.resolve()
      .then(() => {
        return addPdsAPI(payload);
      })
      .then(response => {
        const result = response.data || {};
        // const { info } = result.info || {}
        // const status = response.status || []
        commit(t.ADD_PDS_SUCCESS, { result });
        return response;
      })
      .catch(err => {
        commit(t.ADD_PDS_FAIL);
        throw err;
      });
  }
};
